import React, { Component } from "react";
import {
  Select,
  Radio,
  Space,
  message,
  Spin,
  Checkbox,
  Input,
  RadioGroup,
} from "antd";
import Bridge from "../../../../utils/Bridge";
import { LE_STUDY_DEMOGRAPHICS_CONTENT, RESEARCH_TYPE } from "../../../../utils/consts";
import dayjs from "dayjs";

import englishJson from "../../../../utils/language/leStudy/english.json";
import spanishJson from "../../../../utils/language/leStudy/spanish.json";
import { logEvent } from "../../../../utils/analytics";

export default class LanguageEducation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      highest_education: "",
      spanish_literacy: "",
      english_literacy: "",
      is_english_first_language: "",
      if_not_english_first_language: "",
      if_not_english_first_language_other: "",
      education_other_specification: "",
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.demographics.le_study
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          if (response.data.length > 0) {
            for (let item of response.data) {
              if (item.field == "What is your first language?") {
                this.setState({ is_english_first_language: item.value });
              }
              if (item.field == "Other Language") {
                this.setState({
                  if_not_english_first_language_other: item.value,
                });
              }
              if (item.field == "Spanish Literacy") {
                this.setState({ spanish_literacy: item.value });
              }
              if (item.field == "English Literacy") {
                this.setState({ english_literacy: item.value });
              }
              if (item.field == "Highest level of education") {
                
                // Normalize the value to match radio options
                let normalizedValue = item.value;
                if (normalizedValue.includes("Bachelor's degree")) {
                  normalizedValue = "Bachelor's degree";
                } else if (normalizedValue.includes("Master's degree")) {
                  normalizedValue = "Master's degree";
                } else if (
                  normalizedValue.includes("Doctorate") ||
                  normalizedValue.includes("Ph.D")
                ) {
                  normalizedValue = "Doctorate or Ph.D.";
                } else if (normalizedValue.includes("Associate degree")) {
                  normalizedValue =
                    "Associate degree, vocational school, or equivalent";
                } else if (normalizedValue.includes("High school")) {
                  normalizedValue = "High school graduate / GED";
                }
                this.setState({ highest_education: normalizedValue });
              }
              if (item.field == "Other Education") {
                this.setState({ education_other_specification: item.value });
              }
            }
          }
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  save = (goToNextStep = true) => {
    const formData =
      RESEARCH_TYPE == "LE Study"
        ? this.props.language == "English"
          ? englishJson
          : spanishJson
        : englishJson;
    const saveForLater = !goToNextStep;

    if (goToNextStep) {
      if (!this.state.is_english_first_language) {
        message.warning(formData.page.demographicQuestions.messages.validation.firstLanguageRequired);
        return;
      }
      if (!this.state.spanish_literacy) {
        message.warning(formData.page.demographicQuestions.messages.validation.spanishLiteracyRequired);
        return;
      }
      if (!this.state.english_literacy) {
        message.warning(formData.page.demographicQuestions.messages.validation.englishLiteracyRequired);
        return;
      }
      if (!this.state.highest_education) {
        message.warning(formData.page.demographicQuestions.messages.validation.highestEducationRequired);
        return;
      }
    }

    let missingFields = [];
    const isBlank = (v) => v === null || v === undefined || String(v).trim() === "";

    if (isBlank(this.state.is_english_first_language)) missingFields.push("What is your first language?");
    else if (this.state.is_english_first_language === "Other" && isBlank(this.state.if_not_english_first_language_other)) {
      missingFields.push("Other Language");
    }

    if (isBlank(this.state.spanish_literacy)) missingFields.push("Spanish Literacy");
    if (isBlank(this.state.english_literacy)) missingFields.push("English Literacy");
    
    if (isBlank(this.state.highest_education)) missingFields.push("Highest level of education");
    else if (this.state.highest_education === "Other" && isBlank(this.state.education_other_specification)) {
      missingFields.push("Other Education");
    }

    const isLanguageEducationComplete = missingFields.length === 0 ? 1 : 0;

    let questions = [
      ...(saveForLater
        ? [
            {
              parent_field: "Save",
              field: "Save for later date",
              value: dayjs().format("MM/DD/YYYY HH:mm"),
            },
          ]
        : []),
      {
        parent_field: "Language Education Save Type",
        field: "Language Education Save Type",
        value: saveForLater ? "Save for Later" : "Save Language Education",
      },
      {
        parent_field: "Is Language Education Fields Submitted",
        field: "Is Language Education Fields Submitted",
        value: isLanguageEducationComplete,
      },
      {
        parent_field: "Language Education Missing Fields",
        field: "Language Education Missing Fields",
        value: JSON.stringify(missingFields),
      },
      {
        parent_field: "What is your first language?",
        field: "What is your first language?",
        value: this.state.is_english_first_language,
        subId:
          LE_STUDY_DEMOGRAPHICS_CONTENT.find(
            (item) => item.field == "firstLanguage"
          )?.content.find(
            (item) => item.subtitle == this.state.is_english_first_language
          )?.subId || "",
      },
      {
        parent_field: "Other Language",
        field: "Other Language",
        value: this.state.if_not_english_first_language_other,
      },
      {
        parent_field: "Spanish Literacy",
        field: "Spanish Literacy",
        value: this.state.spanish_literacy,
        subId:
          LE_STUDY_DEMOGRAPHICS_CONTENT.find(
            (item) => item.field == "spanishLiteracy"
          )?.content.find(
            (item) => item.subtitle == this.state.spanish_literacy
          )?.subId || "",
      },
      {
        parent_field: "English Literacy",
        field: "English Literacy",
        value: this.state.english_literacy,
        subId:
          LE_STUDY_DEMOGRAPHICS_CONTENT.find(
            (item) => item.field == "englishLiteracy"
          )?.content.find(
            (item) => item.subtitle == this.state.english_literacy
          )?.subId || "",
      },
      {
        parent_field: "Highest level of education",
        field: "Highest level of education",
        value: this.state.highest_education,
        subId:
          LE_STUDY_DEMOGRAPHICS_CONTENT.find(
            (item) => item.field == "educationLevel"
          )?.content.find(
            (item) =>
              item.subtitle.toLocaleLowerCase() ==
              this.state.highest_education.toLocaleLowerCase()
          )?.subId || "",
      },
      {
        parent_field: "Other Education",
        field: "Other Education",
        value: this.state.education_other_specification,
      }
    ];
    let params = {
      eals_id: localStorage.getItem("ap_eals_id"),
      data: JSON.stringify(questions),
      step: "3",
      action_type: this.props.is_update == true ? "update" : "insert",
    };
    this.setState({ loading: true });
    Bridge.demographics.le_study
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          logEvent("demographics_saved", { section: "language_education" });
          const formData =
            RESEARCH_TYPE == "LE Study"
              ? this.props.language == "English"
                ? englishJson
                : spanishJson
              : englishJson;
          message.success(
            formData.page.demographicQuestions.messages
              .demographicsDataAddedSuccessfully
          );
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                this.props.set_active_step(5);
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  render() {
    const formData =
      this.props.language == "English" ? englishJson : spanishJson;
    return (
      <div>
        <div className="header">
          <h3>
            {
              formData.page.demographicQuestions.fields.languageEducation
                .innerTitle
            }
          </h3>
          <div className="white-block"></div>
        </div>
        {this.props.language ? (
          <Spin spinning={this.state.loading}>
            <div className="form-fields">
            <p className="manadatory-note">
              <strong className="text-danger">
                {formData.page.demographicQuestions.note}:
              </strong>{" "}
              {formData.page.demographicQuestions.allFieldsMandatory}
            </p>
            <div className="form-group">
              <label className="input-heading">
                {
                  formData.page.demographicQuestions.fields.languageEducation
                    .whatIsYourFirstLanguage
                }
              </label>
              <br />
              <Radio.Group
                onChange={(e) =>
                  this.setState({
                    is_english_first_language: e.target.value,
                    if_not_english_first_language_other: "",
                  })
                }
                value={this.state.is_english_first_language}
                direction="vertical"
              >
                <Space direction="horizontal">
                  {formData.page.demographicQuestions.fields.languageEducation.firstLanguageOptions.map(
                    (item, index) => {
                      return <Radio value={item.value}>{item.label}</Radio>;
                    }
                  )}
                </Space>
              </Radio.Group>{" "}
              <br />
              {this.state.is_english_first_language == "Other" && (
                <>
                  <br />
                  <label className="input-heading mb-0 mt-2">
                    {
                      formData.page.demographicQuestions.fields
                        .languageEducation.otherFirstLanguageOptions
                    }
                  </label>
                  <br />
                  <input
                    type="text"
                    name="if_not_english_first_language_other"
                    placeholder={
                      formData.page.demographicQuestions.fields
                        .languageEducation.otherFirstLanguageOptions
                    }
                    className="mt-3"
                    value={this.state.if_not_english_first_language_other}
                    onChange={(e) => {
                      this.setState({
                        if_not_english_first_language_other: e.target.value,
                      });
                    }}
                  />
                </>
              )}
            </div>
            <div className="form-group">
              <label className="input-heading">
                {
                  formData.page.demographicQuestions.fields.languageEducation
                    .spanishLiteracy
                }
              </label>
              <br />
              <Radio.Group
                onChange={(e) =>
                  this.setState({
                    spanish_literacy: e.target.value,
                  })
                }
                value={this.state.spanish_literacy}
                direction="vertical"
              >
                <Space direction="horizontal">
                  {formData.page.demographicQuestions.fields.languageEducation.yesNoOptions.map(
                    (item, index) => {
                      return <Radio value={item.value}>{item.label}</Radio>;
                    }
                  )}
                </Space>
              </Radio.Group>
            </div>
            <div className="form-group">
              <label className="input-heading">
                {
                  formData.page.demographicQuestions.fields.languageEducation
                    .englishLiteracy
                }
              </label>
              <br />
              <Radio.Group
                onChange={(e) =>
                  this.setState({
                    english_literacy: e.target.value,
                  })
                }
                value={this.state.english_literacy}
                direction="vertical"
              >
                <Space direction="horizontal">
                  {formData.page.demographicQuestions.fields.languageEducation.yesNoOptions.map(
                    (item, index) => {
                      return <Radio value={item.value}>{item.label}</Radio>;
                    }
                  )}
                </Space>
              </Radio.Group>
            </div>
            <div className="form-group">
              <label className="input-heading">
                {
                  formData.page.demographicQuestions.fields.languageEducation
                    .highestLevelOfEducation
                }{" "}
              </label>
              <br />
              <Radio.Group
                onChange={(e) =>
                  this.setState({
                    highest_education: e.target.value,
                    education_other_specification: "",
                  })
                }
                value={this.state.highest_education}
                direction="vertical"
              >
                <Space direction="vertical">
                  {formData.page.demographicQuestions.fields.languageEducation.highestLevelOfEducationOptions.map(
                    (item, index) => {
                      return <Radio value={item.value}>{item.label}</Radio>;
                    }
                  )}
                </Space>
              </Radio.Group>
              {this.state.highest_education == "Other" && (
                <div>
                  <label className="input-heading mt-2 mb-2">
                    {
                      formData.page.demographicQuestions.fields
                        .languageEducation.pleaseSpecifyYourEducationLevel
                    }
                  </label>
                  <br />
                  <input
                    type="text"
                    name="education_other_specification"
                    placeholder={
                      formData.page.demographicQuestions.fields
                        .languageEducation.pleaseSpecifyYourEducationLevel
                    }
                    className=""
                    value={this.state.education_other_specification}
                    onChange={(e) => {
                      this.setState({
                        education_other_specification: e.target.value,
                      });
                    }}
                  />
                </div>
              )}
            </div>
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button"
                  style={{
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save(false)}
                >
                  {formData.page.demographicQuestions.button.saveForLater}
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save(true)}
                >
                  {formData.page.demographicQuestions.button.save}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{
                    padding: "9px 28px 10px 21px",
                  }}
                  className="submit-button"
                  onClick={() => this.props.set_active_step(3)}
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  {formData.page.demographicQuestions.button.previous}
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save(false)}
                >
                  {formData.page.demographicQuestions.button.saveForLater}{" "}
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save(true)}
                >
                  {formData.page.demographicQuestions.button.savenext}{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
            </div>
          </Spin>
        ) : (
          <div className="form-fields">
            <div style={{ textAlign: "center", padding: "50px" }}>
              <Spin size="large" />
            </div>
            <div className="white-block"></div>
          </div>
        )}
      </div>
    );
  }
}
